import { L as w } from "./reactive-element-BDpydG15-BOs0_4cf.js";
import "./index-BqflxSah.js";
import { s as k } from "./lit-element-DC8UPTKS-4MAMRHpW.js";
import { property as h } from "./index-Ba2D8NOp.js";
import { state as A } from "./index-3_KllEcQ.js";
import { unsafeStatic as P } from "./index-QWNUvlPp.js";
var I = (o, e, t) => {
  if (!e.has(o))
    throw TypeError("Cannot " + t);
}, T = (o, e, t) => (I(o, e, "read from private field"), e.get(o)), R = (o, e, t) => {
  if (e.has(o))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(o) : e.set(o, t);
}, L = (o, e, t, r) => (I(o, e, "write to private field"), e.set(o, t), t), D = /* @__PURE__ */ ((o) => (o.NO_SYNC = "no-sync", o))(D || {}), g = /* @__PURE__ */ ((o) => (o.VISIBLE = "visible", o.IDLE = "idle", o.INTERACTION = "interaction", o.MEDIA = "media", o.DEFINED = "defined", o))(g || {}), m = /* @__PURE__ */ ((o) => (o.BLUR = "beacon-event-blur", o.CHANGE = "beacon-event-change", o.CLICK = "beacon-event-click", o.FOCUS = "beacon-event-focus", o.HIDE = "beacon-event-hide", o.INPUT = "beacon-event-input", o.KEYDOWN = "beacon-event-keydown", o.MOUSEDOWN = "beacon-event-mousedown", o.MOUSEENTER = "beacon-event-mouseenter", o.MOUSELEAVE = "beacon-event-mouseleave", o.RENDER = "beacon-event-render", o.SORT = "beacon-event-sort", o.DEFERRED_CHILD = "beacon-event-deferred-child", o.RENDER_ACTION_ZONE = "beacon-event-render-action-zone", o.RENDER_TABLE_CARDS = "beacon-event-render-table-cards", o.LANGUAGE_SELECT = "beacon-event-language-select", o.PLAY = "beacon-event-play", o.CLOSE = "beacon-event-close", o.OPEN = "beacon-event-open", o.NAV_LANGUAGE_SELECT = "beacon-event-language-selected", o.CLOSE_ACTIVE_NAV_ITEM = "beacon-event-close-active-nav-item", o.ELEMENT_READY = "beacon-event-element-ready", o.ACTIVE_NAV_ITEM = "beacon-event-active-nav-item-change", o.DRILLDOWN = "beacon-event-drilldown", o.DRILLUP = "beacon-event-drillup", o.HEADER_ZONE_CLICK = "beacon-event-navigation-header-zone-click", o.COUNTRY_SELECTOR_CLOSE = "beacon-event-country-selector-close", o.COUNTRY_SELECTOR_OPEN = "beacon-event-country-selector-open", o.COUNTRY_FLAG_CHANGE = "beacon-event-country-flag-change", o.HAS_CURRENT_LINK = "beacon-event-has-current-link", o.REGISTER = "beacon-event-register", o.SKIP_LINK_CLICK = "beacon-event-skip-link-click", o.METRICS_SECTION_CHANGE = "beacon-event-metrics-section-change", o.METRICS_LOCATION_CHANGE = "beacon-event-metrics-location-change", o.METRICS_ID_CHANGE = "beacon-event-metrics-id-change", o.NAVIGATION_LINK_CLICK = "beacon-event-navigation-link-click", o))(m || {}), M = /* @__PURE__ */ ((o) => (o.CLOSE = "close", o.KEYDOWN = "keydown", o.SCROLL = "scroll", o.CLICK = "click", o.FOCUSOUT = "focusout", o))(M || {});
const _ = w`[beacon-tag-name]:not([focus-override]) *:focus-visible:not(a:not([focus-override])){--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){[beacon-tag-name]:not([focus-override]) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, $ = w`:host(:not([focus-override])) *:not(a:not([focus-override])):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));box-shadow:0 0 0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus)),0 0 0 var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-inner, var(--beacon-color-border-focus));outline-offset:0;position:relative;z-index:1}:host(:not([focus-override])) a:not([focus-override]):focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));background-color:var(--beacon-system-color-background-link-focus, var(--beacon-color-background-link-focus))!important;border-block-end-color:unset;box-shadow:0 var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) 0 0 var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus));color:var(--beacon-system-color-text-set-navy, var(--beacon-color-text-set-navy))!important;outline:none;text-decoration:none}@media (forced-colors: active){:host(:not([focus-override])) a:not([focus-override]):focus-visible{border-block-end:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) solid var(--beacon-system-color-border-link-focus, var(--beacon-color-border-link-focus))}}`, U = w`[beacon-tag-name]:where([reset-spacing]) *{margin:0;padding:0}`, j = w`:host{border:initial;box-sizing:border-box;display:block;font-size:initial;font-style:initial;font-variant:initial;font-weight:initial;line-height:initial;white-space:initial;word-break:break-word;word-spacing:initial;text-align:initial;text-indent:initial;text-transform:initial}:host *,:host *:before,:host *:after{box-sizing:inherit}input,button,textarea,select{font:inherit;letter-spacing:inherit}button{color:inherit;cursor:pointer}ul,ol{list-style-position:initial;list-style-type:revert}table{caption-side:initial;empty-cells:initial;border-collapse:initial;border-spacing:initial}`, H = w`.has-cell-padding{padding-block:var(--beacon-cell-space-padding);padding-inline:var(--beacon-cell-space-padding)}.has-component-padding{padding-block:var(--beacon-component-space-padding);padding-inline:var(--beacon-component-space-padding)}@media (width >= 1600px){:host{--beacon-space-default: calc(10 * var(--beacon-unit-base)) !important;--beacon-grid-layout-space-margin: 10rem !important;--beacon-grid-gutter-size-inline: 2rem !important}}:host{color:var(--beacon-system-color-text-standard, var(--beacon-color-text-default));font-family:var(--beacon-system-font-family, var(--beacon-font-family-default));-webkit-font-smoothing:antialiased}[lang=zh]{font-family:var(--beacon-system-font-family, var(--beacon-font-family-cjk))}a,::slotted(a){color:var(--beacon-system-color-text-link, var(--beacon-color-hyperlink-default))}a:not(:is(:hover,:focus)){text-decoration:none}:host(:not([motion-state=enabled])),:host(:not([motion-state=enabled])) :is(*,*:before,*:after),:host(:not([motion-state=enabled])) ::slotted(*:not([motion-state=enabled])){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}@media (prefers-reduced-motion: reduce){:host([motion-state=enabled]),:host([motion-state=enabled]) :is(*,*:before,*:after),:host([motion-state]),:host([motion-state]) :is(*,*:before,*:after){animation:none;animation-duration:.01ms!important;animation-iteration-count:1!important;scroll-behavior:auto!important;transition:none!important}}`;
var O = /* @__PURE__ */ ((o) => (o.CLICKABLE = "data-metrics-clickable", o.TYPE = "data-metrics-type", o.TEXT = "data-metrics-link-text", o.LOCATION = "data-metrics-location", o))(O || {});
const p = class {
};
p.setPropertyOnEvent = (o, e, t, r) => {
  try {
    Object.defineProperty(o, t, {
      value: r || e[`${t}`],
      writable: !1
    });
  } catch {
  }
}, p.getAnalyticsEvents = () => {
  const o = ["gesture", "click", "touch", "change"];
  return Object.keys(window).filter((e) => /^on/.test(e) && new RegExp(o.join("|")).test(e));
}, p.setHostEventHandlerForAnalytics = (o, e) => {
  var t;
  const r = p.getAnalyticsEvents(), n = "beaconVersion";
  for (const a of r) {
    const i = a.slice(2);
    (t = o.shadowRoot) == null || t.addEventListener(
      i,
      (s) => {
        var c;
        const u = new s.constructor(i, s);
        p.setPropertyOnEvent(u, null, n, e);
        for (const f in s)
          p.setPropertyOnEvent(u, s, f);
        (c = o.shadowRoot) != null && c.contains(s.target) && o.dispatchEvent(u);
      },
      !0
    );
  }
};
let K = p;
function ee(o, e) {
  !o || !e || o instanceof SVGElement && (o.setAttribute(O.CLICKABLE, "true"), o.setAttribute(O.TYPE, "BTN"), o.setAttribute(O.TEXT, e));
}
function C(o, e, t, r) {
  const n = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...t
  });
  return o.dispatchEvent(n), n;
}
const N = (o) => !!o.deferrable, V = (o) => {
  var e, t;
  return (!!((e = o.deferList) != null && e.includes(g.VISIBLE)) || !!((t = o.getAttribute("defer-until")) != null && t.includes(g.VISIBLE))) && o.isDeferUntilParent;
}, x = (o) => !!navigator.vendor && navigator.vendor.indexOf(o) > -1;
function B(o) {
  return `${o}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, t, r) => `${t.toUpperCase() + r}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const F = "3.4.0", Y = {
  rootMargin: "1500px",
  threshold: 0.1
}, b = {
  version: F,
  hidden: "hidden",
  safari: "Apple",
  divTagName: "div",
  deprecatedPropertyKeys: ["alternateAttributes", "sync", "alternateSlot"],
  defaultDeferOptions: Y
}, S = (o) => {
  for (const e of o)
    if (e !== void 0)
      return e;
};
var G = Object.defineProperty, l = (o, e, t, r) => {
  for (var n = void 0, a = o.length - 1, i; a >= 0; a--)
    (i = o[a]) && (n = i(e, t, n) || n);
  return n && G(e, t, n), n;
}, y;
const v = class extends k {
  constructor() {
    super(...arguments), R(this, y, void 0), L(this, y, !1), this.isDeferUntilParent = !1, this.deferrable = !0, this.focusOverride = !1, this.resetSpacing = !1, this.beaconTagName = "", this.version = b.version, this.motionState = "disabled", this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches, this.alternateSlots = /* @__PURE__ */ new Map(), this.onslotchange = (e) => {
      var t;
      const r = (t = e.target.name) != null ? t : "";
      this.slotDeprecationWarn(r);
    }, this.resolvedDeferOptions = {
      root: document,
      rootMargin: b.defaultDeferOptions.rootMargin,
      threshold: b.defaultDeferOptions.threshold
    }, this.deferUntilVisible = () => new Promise((e) => {
      if (!("IntersectionObserver" in window))
        e();
      else {
        const t = new IntersectionObserver((r) => {
          const [n] = r;
          n.isIntersecting && (t.disconnect(), e());
        }, this.getResolvedDeferOptions() || null);
        t.observe(this);
      }
    }), this.deferUntilIdle = () => {
      const e = new Promise((t) => {
        document.readyState !== "complete" ? window.addEventListener("load", () => t(), { once: !0 }) : t();
      });
      return "requestIdleCallback" in window ? Promise.all([
        new Promise((t) => {
          requestIdleCallback(() => {
            t();
          });
        }),
        e
      ]) : e;
    }, this.deferredChildEventHandler = (e) => new Promise((t) => {
      var r;
      e instanceof CustomEvent && (r = e.detail) != null && r.type ? (this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(e.detail.type).then(() => t())) : t();
    }), this.renderLightDOMStyles = (e = `${this.beaconTagName}-light-DOM-styles`) => {
      const t = [], r = new Set(this.constructor.lightDOMStyles.flat(1 / 0));
      for (const n of r)
        t.push(n);
      t.reverse().forEach((n, a) => {
        var i;
        const s = document.createElement("style");
        s.setAttribute("slot", "lightDOM");
        let c = !1;
        if (s.textContent = n.toString(), e) {
          const u = Math.abs(a - t.length), f = `${e}-${u}`, E = this.getClosestHost();
          s.id = f, (E && (i = E == null ? void 0 : E.shadowRoot) != null && i.querySelector(`#${f}`) || !E && document.querySelector(`#${f}`)) && (c = !0);
        }
        c || this.prepend(s);
      });
    }, this.renderComponentModeStyles = (e = `${this.beaconTagName}-mode-styles`) => {
      var t;
      (t = this.componentModeStyles) == null || t.forEach((r, n) => {
        const a = document.createElement("style");
        a.textContent = r.toString();
        const i = `${e}-${n}`;
        a.id = i, !document.querySelector(`#${i}`) && document.head.append(a);
      });
    }, this.getScopedTag = (e) => {
      if (!e)
        return null;
      const t = this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e;
      return P(t);
    };
  }
  /**
   * Extends Lit's definition of `observedAttributes`.
   *
   * Returns a list of attributes corresponding to the registered properties.
   * @nocollapse
   * @category attributes
   */
  static get observedAttributes() {
    const e = [];
    return this.hasDeprecatedProperties && this.alternateAttributesMap.forEach((t, r) => {
      this.elementProperties.has(t) && e.push(r);
    }), e.push(...super.observedAttributes), e;
  }
  /**
   * Extends Lit's default attributeChangedCallback to support deprecated properties.
   *
   * @param name Attribute name
   * @param _old Old value
   * @param value New value
   */
  attributeChangedCallback(e, t, r) {
    const { alternateAttributesMap: n, hasDeprecatedProperties: a, elementProperties: i } = this.constructor;
    if (a && n.size > 0) {
      const s = n.get(e), c = i.get(s), u = this.getPropertyOptions(e).alternateSlot;
      if (s)
        if (s !== D.NO_SYNC && (r === null ? this.removeAttribute((c == null ? void 0 : c.attribute) || s) : this.setAttribute((c == null ? void 0 : c.attribute) || s, r || "")), u) {
          const f = this.createPropertyDeprecationForSlotMessage(e, u);
          console.warn(f);
        } else
          console.warn(this.createPropertyDeprecationMessage(e, s, c == null ? void 0 : c.attribute));
    }
    super.attributeChangedCallback(e, t, r);
  }
  /**
   * Generates a console message to log when deprecated properties were used.
   *
   * @param name attribute that triggered the message
   * @param property property that the attribute aligns to
   * @param attribute correct attribute to use
   */
  createPropertyDeprecationMessage(e, t, r) {
    let n = `Beacon Warning: [${e}] will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release.`;
    return t !== D.NO_SYNC && (n += ` Start using [${r || t}] instead to avoid future disruptions.`), n;
  }
  /**
   * Generates a console message to log when a deprecated property is used
   * and should instead use the designated slot
   * @param property the name of the property being deprecated
   * @param slot the designated slot to use instead
   */
  createPropertyDeprecationForSlotMessage(e, t) {
    return `Beacon Warning: '${e}' will be deprecated as a prop of <${this.beaconTagName.toLowerCase()}> in a future release. Start using the slot: '${t}' instead to avoid future disruptions`;
  }
  /**
   * Extend's Lit's `createProperty` method for our own uses.
   * @param name Property Name
   * @param options Options for the property
   */
  static createProperty(e, t) {
    if (t) {
      const { alternateAttributes: r, attribute: n } = t, a = Object.prototype.hasOwnProperty.call(t, "sync");
      if (b.deprecatedPropertyKeys.forEach((i) => {
        Object.prototype.hasOwnProperty.call(t, i) && (this.hasDeprecatedProperties = !0);
      }), r && r.forEach((i) => {
        this.alternateAttributesMap.set(i, e);
      }), a && !t.sync) {
        const i = n != null ? n : e;
        this.alternateAttributesMap.set(i, D.NO_SYNC);
      }
    }
    super.createProperty(e, t);
  }
  /**
   * This is used to return the property options of a property when given only its attribute name,
   * e.g. the property pageTitle with an attribute name of 'page-title' will have no way of accessing its options
   * directly when attempting to grab the options with 'page-title' and elementProperties.get().
   * @param name the resolved attribute name of a `@property()` decorated property
   * @returns the options passed in `@property()` e.g. `{attribute: 'attribute-name', reflect: true}`
   */
  getPropertyOptions(e) {
    var t;
    const { elementProperties: r } = this.constructor;
    return (t = r.get(e)) != null ? t : [...r.values()].find((n) => n.attribute === e);
  }
  /**
   * Getter that returns private resolvedDeferOptions
   * @returns resolvedDeferOptions that are passed to an IntersectionObserver
   */
  getResolvedDeferOptions() {
    return this.resolvedDeferOptions;
  }
  /**
   * Converts space separated list prop of `defer-until` to a DeferUntil enum array
   */
  get deferList() {
    var e, t;
    return (t = (e = this.deferUntil) == null ? void 0 : e.split(" ").map((r) => r).filter((r) => !!r)) != null ? t : [];
  }
  /**
   * Logs a warning based on the slot name provided and details from the alternate slots map
   *
   * @param slotName name of the slot that has changed
   */
  slotDeprecationWarn(e) {
    const t = this.alternateSlots.get(e);
    if (t !== void 0) {
      let r;
      const n = `The '${e}' for for '${this.beaconTagName}'`;
      Object.keys(t).some((a) => a.match("alternate")) ? t.alternateAttribute ? r = `will be replaced by the element property '${t.alternateAttribute}'` : r = `will be replaced by the '${t.alternateSlots}' slot` : r = "will be removed", console.warn(`Beacon Deprecation Warning: ${n} ${r} in foundation@${t.version}`);
    }
  }
  /**
   * A setter that takes user input deferOptions and resolves them compared to existing deferOptions. Enables the setting
   * of isolated deferOptions and leaves unchanged options previously set intact.
   * @param options the defer-options object used in IntersectionObserver.
   */
  setDeferOptions(e) {
    if (!e)
      return;
    const t = { ...this.resolvedDeferOptions };
    this.resolvedDeferOptions = {
      root: S([e == null ? void 0 : e.root, t == null ? void 0 : t.root, document]),
      rootMargin: S([
        e == null ? void 0 : e.rootMargin,
        t == null ? void 0 : t.rootMargin,
        b.defaultDeferOptions.rootMargin
      ]),
      threshold: S([
        e == null ? void 0 : e.threshold,
        t == null ? void 0 : t.threshold,
        b.defaultDeferOptions.threshold
      ])
    };
  }
  /**
   * Hides the visibility of the component. Used when component is deferred until specified condition.
   * @returns void
   */
  setDeferVisibilityStyles() {
    x(b.safari) || (this.style.visibility = b.hidden);
  }
  /**
   * Sets the component styles to visibile. Used when component meets condition specified to defer until.
   * @returns void
   */
  removeDeferVisibilityStyles() {
    x(b.safari) || this.style.removeProperty("visibility");
  }
  /**
   * Searches for a parent of component with defer-until attribute that is not solely defer-until="defined".
   * @returns closest lightDOM parent with [defer-until] attribute or null
   */
  getClosestDeferredParent() {
    const e = '[defer-until]:not([defer-until="defined"])', t = this.closest(e);
    if (t && N(t))
      return t;
    const r = this.getClosestHost();
    if (r) {
      const n = r.closest(e);
      if (n && N(n))
        return n;
    }
    return null;
  }
  /**
   * Runs in shadowDOM context. This method searches for the ShadowRoot then returns host of ShadowRoot.
   * @returns host element of this component of the shadowDOM
   */
  getClosestHost() {
    let e = this && this.parentNode;
    for (; e; ) {
      if (e instanceof ShadowRoot)
        return e.host;
      e = e.parentNode;
    }
    return null;
  }
  /**
   * Selects which deferUntil handler method to run on component.
   * @param deferUntilCriteria DeferUntil option that determines how component should defer.
   */
  selectDeferUntilHandler(e) {
    return new Promise((t) => {
      e.includes(g.VISIBLE) ? (this.setDeferVisibilityStyles(), this.deferUntilVisible().then(() => {
        this.removeDeferVisibilityStyles(), t();
      })) : e.includes(g.IDLE) ? (this.setDeferVisibilityStyles(), this.deferUntilIdle().then(() => {
        this.removeDeferVisibilityStyles(), t();
      })) : t();
    });
  }
  /**
   * Method that handles setup of deferUntil handler when deferUntil is configured locally via deferUntil prop on the component.
   */
  handleLocalDeferUntil() {
    return new Promise((e) => {
      this.deferOptions && this.setDeferOptions(this.deferOptions), this.selectDeferUntilHandler(this.deferList).then(() => e());
    });
  }
  /**
   * Method that looks for the closest element to the component with 'defer-until' attribute and either
   * applies the parent's deferUntil logic to the component immediately, if the parent is already registered as `isDeferUntilParent`,
   * or adds an eventListener to toggle parent's deferUntil logic on component once parent has emitted the beacon-event-deferred-child Event.
   * @param closestDeferredParent is the closest element to the component that has the 'defer-until' attribute set.
   */
  handleParentalDeferUntil(e) {
    return new Promise((t) => {
      if (e === null)
        t();
      else if (V(e))
        this.selectDeferUntilHandler(e.deferList).then(() => t());
      else {
        const r = (n) => {
          this.deferredChildEventHandler(n).then(() => {
            e.removeEventListener(m.DEFERRED_CHILD, r), t();
          });
        };
        e.addEventListener(m.DEFERRED_CHILD, r);
      }
    });
  }
  /**
   * This method handles defer logic. If component has deferUntil prop set, it calls method to handle deferUntil logic locally.
   * Else if component has a closest element with 'defer-until' attribute set, it handles deferUntil based on closestDeferredParent's deferUntil settings.
   * If neither of the above criteria match, it completes connectedCallback.
   */
  handleDefer() {
    return new Promise((e) => {
      if (!this.deferrable || this.motionState === "enabled")
        e();
      else if (this.deferUntil)
        this.registerAsDeferUntilParent(), this.handleLocalDeferUntil().then(() => e());
      else {
        const t = this.getClosestDeferredParent();
        t ? this.handleParentalDeferUntil(t).then(() => e()) : e();
      }
    });
  }
  /**
   * Method that registers a component as parental component that can trigger deferUntil logic in child components. It should be placed in connectedCallback
   * of all components that need to trigger deferUntil logic in child components.
   */
  registerAsDeferUntilParent() {
    if (this.deferOptions && this.setDeferOptions(this.deferOptions), this.deferList.includes(g.VISIBLE)) {
      const e = new IntersectionObserver((t) => {
        for (const r of t)
          r.target && (this.isDeferUntilParent = !0, this.emitDeferredChild(), e.disconnect());
      }, this.getResolvedDeferOptions() || null);
      e.observe(this);
    }
  }
  /**
   * @returns the scope prefix from the beginning of the tagName.
   */
  getScopedTagPrefix() {
    const e = this.tagName.toLowerCase().split("-beacon")[0];
    return e.startsWith("beacon") ? "" : e;
  }
  /**
   * Defines this web component in the CustomElementRegistry.
   * @param tagNamePrefix lowercase string that prefixes default component tag names for scoping purposes
   */
  static registerComponent(e) {
    if (this.tagName) {
      const t = `${e ? `${e}-` : ""}${this.tagName}`;
      if (!customElements.get(t)) {
        const r = class extends this {
        };
        Object.defineProperty(r, "name", { value: B(t) }), customElements.define(t, r), customElements.whenDefined(t).then(() => {
          const n = new CustomEvent(m.REGISTER, { detail: t });
          document.dispatchEvent(n);
        }).catch((n) => {
          console.error(`Error defining Beacon Component ${t} in CustomElementsRegistry: `, n);
        });
      }
    }
  }
  /**
   * This will return beacon tag name to scoped tag Name
   * @param tag beaconTagName
   * @returns Scoped tagName
   */
  getScopedTagName(e) {
    return e ? this.getScopedTagPrefix() ? `${this.getScopedTagPrefix()}-${e}` : e : "";
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-click - emits when clicked
   */
  emitClick(e) {
    C(this, m.CLICK, !!this.onBeaconClick && this.onBeaconClick(e));
  }
  /**
   * @param event
   * @event {BeaconEvents} beacon-event-keydown - emits when a keydown event would be fired
   */
  emitKeydown(e, t) {
    C(this, m.KEYDOWN, !!this.onBeaconKeydown && this.onBeaconKeydown(t));
  }
  /**
   * Emitter of beacon-event-deferred-child event used by components registered as deferUntilParents.
   * @param event
   * @event {BeaconEvents} beacon-event-deferred-child - signals to children of a deferUntil parent that they should behave as deferUntil components
   */
  emitDeferredChild(e) {
    C(this, m.DEFERRED_CHILD, {
      detail: {
        element: this,
        type: this.deferList
      }
    });
  }
  /**
   * Emits a beacon-event-keydown event as a default to mousedown handling
   * @param event
   */
  handleKeydown(e) {
    this.emitKeydown(e);
  }
  /**
   * Check if the component has a specific mixin applied.
   * @param name Name of the mixin to look for.
   * @returns True if the class contains that mixin.
   */
  hasMixin(e) {
    var t;
    try {
      if (!((t = this.constructor.mixins) != null && t.includes(e)))
        throw new Error(`This class does not implement ${e}.`);
      return !0;
    } catch (r) {
      return console.error(r), !1;
    }
  }
  /**
   * Check for a field with a specific value on the class.
   *
   * Useful when a mixin relies on the existance of another mixin.
   *
   * @param field Class property to check for on the mixin.
   * @param value Value of the given class field to check for.
   * @returns True if the value of the field is the same.
   */
  hasFieldAndValue(e, t) {
    try {
      if (!(e in this))
        throw new Error(`${e} does not exist on this: ${this}`);
      return this[e] === t;
    } catch (r) {
      return console.error(r), !1;
    }
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @prerender
   * and is called in connectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of connectedCallback in subclasses
   */
  prerender() {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @postrender
   * and is called in firstUpdated. This method should not be overridden directly.
   * The goal is to prevent direct overrides of firstUpdated in subclasses
   */
  postrender() {
  }
  /**
   * Placeholder method that collects all method functionality that is decorated with @destroy
   * and is called in disconnectedCallback. This method should not be overridden directly.
   * The goal is to prevent direct overrides of disconnectedCallback in subclasses
   */
  destroy() {
  }
  /**
   * Enables or disables motion on this component.
   *
   * Looks for the closest element with `[motion-state]` to find its value and set the motion state of the component equal to that.
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest Element.closest() will return the element itself if it matches the selector.
   */
  setMotionState() {
    if (this.motionState === "enabled")
      return;
    const e = this.closest("[motion-state]"), t = e == null ? void 0 : e.getAttribute("motion-state");
    t && (t === "enabled" || t === "disabled") && (this.motionState = t);
  }
  connectedCallback() {
    this.setMotionState(), this.handleDefer().then(() => {
      super.connectedCallback(), T(this, y) || (K.setHostEventHandlerForAnalytics(this, this.version), L(this, y, !0)), this.renderLightDOMStyles(), this.prerender();
    });
  }
  firstUpdated() {
    this.postrender(), C(this, m.ELEMENT_READY);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.destroy();
  }
};
y = /* @__PURE__ */ new WeakMap(), v.styles = [j, H, $], v.tagName = "", v.shadowRootOptions = { ...k.shadowRootOptions, delegatesFocus: !0 }, v.alternateAttributesMap = /* @__PURE__ */ new Map(), v.hasDeprecatedProperties = !1, v.mixins = [], v.lightDOMStyles = [U, _];
let d = v;
l([
  h({ attribute: "focus-override", type: Boolean, reflect: !0 })
], d.prototype, "focusOverride");
l([
  h({ attribute: "reset-spacing", type: Boolean, reflect: !0 })
], d.prototype, "resetSpacing");
l([
  h({ attribute: "beacon-tag-name", type: String, reflect: !0 })
], d.prototype, "beaconTagName");
l([
  h({ attribute: "beacon-version", reflect: !0 })
], d.prototype, "version");
l([
  h({ attribute: "defer-until" })
], d.prototype, "deferUntil");
l([
  h({ attribute: "defer-options" })
], d.prototype, "deferOptions");
l([
  h({ type: Function })
], d.prototype, "onBeaconClick");
l([
  h({ type: Function })
], d.prototype, "onBeaconKeydown");
l([
  h({ attribute: "motion-state", reflect: !0 })
], d.prototype, "motionState");
l([
  A()
], d.prototype, "prefersReducedMotion");
export {
  M as $,
  C as D,
  O as N,
  d,
  m,
  ee as te
};
